import { User } from '@/api/com/MetaPattern/APP/MDA/User/User';
import { Commit } from 'vuex';

const state = {
  userId: '', // 登录用户ID，为空代表没有登陆
  accountId: '', // 登录账户ID，为空代表没有登陆
  hasInitDone: false // 是否完成初始化（登录以后的初始化）
};

const getters = {};

const mutations = {
  /** 设置当前用户 */
  setUser (states: any, params: User): void {
    if (params !== null) {
      states.userId = params.id;
      states.accountId = params.loginAccountId;
    } else {
      states.userId = '';
      states.accountId = '';
    }
  },
  setInitDone (states: any, params: boolean): void {
    states.hasInitDone = params;
  }
};

const actions = {
  setUserAction(context: { commit: Commit }, params: User) {
    context.commit('setUser', params);
  },
  setInitDoneAction(context: { commit: Commit }, params: boolean) {
    context.commit('setInitDone', params);
  }
};

export default {
  namespaced: true, // namespaced为false的时候，state,mutations,actions全局可以调用，为true，生成作用域，引用时要声明模块名称
  state,
  getters,
  mutations,
  actions
};
